import styled, { css } from "styled-components";

export const CardContainer = styled.div<{ isOnWide?: boolean }>`
  ${({ isOnWide }) =>
    isOnWide &&
    css`
      display: flex;
      min-width: 320px;
      border: var(--fd-border-widths-border-width-010) solid
        var(--fd-colors-border-subtle);
    `}
`;

export const PoolItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
